import script from "./CreateSupervisorReportDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateSupervisorReportDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CreateSupervisorReportDialog.vue?vue&type=style&index=0&id=fb94cbce&lang=sass"

const __exports__ = script;

export default __exports__